var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6665 44.8333H37.9998M37.9998 44.8333H44.3332M37.9998 44.8333V51.1667M37.9998 44.8333V38.5",
    stroke: "#28475C",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3335 22.5076C6.3335 19.7129 6.3335 18.3155 6.5531 17.1516C7.51986 12.0277 11.5278 8.01973 16.6517 7.05298C17.8157 6.83337 19.213 6.83337 22.0077 6.83337C23.2322 6.83337 23.8444 6.83337 24.4328 6.8884C26.9696 7.12561 29.3758 8.12232 31.3373 9.74834C31.7923 10.1255 32.2252 10.5584 33.091 11.4242L34.8335 13.1667C37.4168 15.75 38.7084 17.0417 40.2552 17.9022C41.1049 18.375 42.0062 18.7483 42.9413 19.0148C44.6435 19.5 46.4702 19.5 50.1235 19.5H51.3068C59.6426 19.5 63.8105 19.5 66.5197 21.9367C66.7689 22.1608 67.0061 22.398 67.2302 22.6472C69.6668 25.3563 69.6668 29.5242 69.6668 37.8601V44.8334C69.6668 56.7756 69.6668 62.7467 65.9568 66.4567C62.2469 70.1667 56.2757 70.1667 44.3335 70.1667H31.6668C19.7246 70.1667 13.7535 70.1667 10.0435 66.4567C6.3335 62.7467 6.3335 56.7756 6.3335 44.8334V22.5076Z",
    stroke: "#28475C",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFolder);
export default __webpack_public_path__ + "static/media/AddFolder.f96b7e434d2d2a58567fe800ca9bab17.svg";
export { ForwardRef as ReactComponent };